module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amcharts/amcharts4/node_modules/@babel/runtime/regenerator/index.js
// module id = 3024
// module chunks = 1